module.exports = __webpack_public_path__ + "static/media/customer-burger-king.a52abab1.png";